import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Component, OnInit, ViewChildren,ViewChild, ElementRef, QueryList } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { CommanSubscribeService } from 'src/app/core/services/comman-subscribe.service';
import { Router } from '@angular/router';
import { StorageService } from 'src/app/core/services/storage.service';
import { environment } from 'src/environments/environment';
@Component({
  selector: 'app-consumer-accept-teams',
  templateUrl: './consumer-accept-teams.component.html',
  styleUrls: ['./consumer-accept-teams.component.scss']
})
export class ConsumerAcceptTeamsComponent implements OnInit {

  isSignature: boolean = true;
  signatureForm: FormGroup;
  clientDetails: any;
  @ViewChild('scrollToMe', {static:false}) scrollToMe: ElementRef;
  channelUrl: any;

  constructor(private matDialogRef: MatDialogRef<ConsumerAcceptTeamsComponent>,private storageService:StorageService,
    private formBuilder: FormBuilder,private toastr: ToastrService ,private commanSubscribeService: CommanSubscribeService,private router:Router) {

      setTimeout(() => {
        this.scrollToMe.nativeElement.scrollIntoView({ behavior: 'smooth' })
        }, 300);
  }
  settingsData:any={}
  ngOnInit() {
    this.clientDetails = environment.clientDetails;
    this.settingsData = this.commanSubscribeService.icWebpageSettingsData;
    this.channelUrl = this.storageService.getItem('channelName')
    if(!this.router.url.includes(this.channelUrl)){
      this.settingsData={}
    }
    this.signatureForm = this.formBuilder.group({
      signatureField1: ['', Validators.required]
    })
  }

  submitSign() {
    if (this.signatureForm.valid) {
      let data = {
        signature: this.signatureForm.value.signatureField1,
        close: false
      }
      this.closeDialog(data);
    } else {
      this.toastr.error("Please enter your signature");
    }
  }

  close() {
    this.closeDialog({ close: true });
  }

  closeDialog(data) {
    this.matDialogRef.close(data);
  }

  onChangeSign(event) {
    // this.signUpdata.signature = event;
  }

  // signComplete() {
  //   this.isSignature = false;
  // this.signatureForm.patchValue({
  //   signatureField1: ''
  // })
  // }

  // signChange() {
  //   this.isSignature = !this.isSignature;
  // this.signatureForm.patchValue({
  //   signatureField1: ''
  // })
  //   this.sigs.first.clear();
  // }

}
